import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconUser } from "@tabler/icons-react";
import { PersonasDef } from "./PersonasDef";

export const PersonasIcon = IconUser;
export const PersonasHelpText = '* Aquí puede ver la lista de todos los Emails de Personas disponibles.';

export class Personas extends Entity<PersonasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PersonasDef(), parentKeys);
        this.Form = import('./PersonasForm').then((module) => module.PersonasForm);
        this.Title = "Personas";
        this.HelpText = PersonasHelpText;
        this.Icon = PersonasIcon;
    }
}